import { toast } from "react-toastify";

// Track last toast to avoid duplicate renders and React-Toastify race conditions
let lastToastTime = 0;
let lastToastMessage = '';
let lastToastId = null;

const registerOutsideClickDismiss = () => {
  if (typeof document === 'undefined') return;

  // Defer so the same click that triggered the action does not dismiss the toast.
  window.setTimeout(() => {
    const handler = (event) => {
      const container = document.querySelector('.Toastify__toast-container');

      if (container && container.contains(event.target)) {
        return;
      }

      if (lastToastId) {
        toast.dismiss(lastToastId);
        lastToastId = null;
      }

      document.removeEventListener('mousedown', handler);
    };

    document.addEventListener('mousedown', handler, { once: true });
  }, 300);
};

const showToast = (type, message) => {
  const now = Date.now();

  if (!message) {
    return;
  }

  // Prevent duplicate toasts within 500ms
  if (message === lastToastMessage && now - lastToastTime < 500) {
    return;
  }

  lastToastTime = now;
  lastToastMessage = message;

  // Dismiss only the previous toast to avoid React-Toastify internal state issues
  if (lastToastId) {
    toast.dismiss(lastToastId);
    lastToastId = null;
  }

  const options = {
    autoClose: 5000,
    closeButton: true,
    draggable: true,
    pauseOnHover: true,
    closeOnClick: true,
    hideProgressBar: false,
    onClose: () => {
      lastToastId = null;
    }
  };

  if (type === 'success') {
    lastToastId = toast.success(message, options);
  } else if (type === 'error') {
    lastToastId = toast.error(message, options);
  } else if (type === 'warning') {
    lastToastId = toast.warning(message, options);
  }

  registerOutsideClickDismiss();
};

export const success = (message) => {
  showToast('success', message);
};

export const danger = (message) => {
  showToast('error', message);
};

export const warning = (message) => {
  showToast('warning', message);
};
